
"use strict";


/**
 * @type Controller
 * @name ConfirmManyDialogCtrl
 * @packageName rundown_dialog_ctrl.js
 *
 * @description
 *
 * The `RundownDialogCtrl` interaction delete mdDialog for rundown
 *
 */
class ConfirmManyDialogCtrl {


    constructor( $scope, $mdDialog, count, option) {

    	//Attach dependicies to class root
    	this.$mdDialog = $mdDialog;

    	//Ugly work around CANCEL button!
    	$scope.cancel = () => {
    		this.cancelButton();
    	};

    	//Ugly work around OPTION button!
    	$scope.option = () => {
    		this.optionButton();
    	};

		//Ugly work around OK button!
    	$scope.ok = (data) => {
    		this.ok(data);
    	};

		$scope.count = count;
		$scope.option = option;
    }


	/*
     * managed CANCEL event from confirm dailog
     */
    cancelButton () {
        this.$mdDialog.cancel();
    }

	/*
     * managed OK event from confirm dailog
     */
    ok (data) {
    	if(data){
			let request = data;
			if (request === 'single') {
				this.$mdDialog.hide('single');
			} else if (request === 'serie') {
				this.$mdDialog.hide('serie');
			}
        } else {
			this.$mdDialog.hide();
        }
	}
}


/*
 * Inject dependicies
 */
ConfirmManyDialogCtrl.$inject = ['$scope', '$mdDialog', 'count', 'option'];


/*
 * Browsify connection: execute controller
 */
module.exports = ConfirmManyDialogCtrl;
